module.exports = __webpack_public_path__ + "img/32_22.0ff3b683.png";